<style>
.layout.row {
  margin-bottom: 20px !important;
}
</style>

<template>
  <div id="pageTable">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex sm12 style="text-align:right">
          <h3 style="float:left">Настройки</h3>
          <v-btn color="pink" dark small fab @click="editOpen()">
            <v-icon>add</v-icon>
          </v-btn>
          <v-btn color="blue" dark small fab @click="refresh()">
            <v-icon>refresh</v-icon>
          </v-btn>
        </v-flex>
        <v-flex lg12>
          <v-card>
            <v-toolbar card color="white">
              <v-text-field flat solo prepend-icon="search" placeholder="Поиск" v-model="search" hide-details
                class="hidden-sm-and-down">
              </v-text-field>
              <v-btn icon>
                <v-icon>filter_list</v-icon>
              </v-btn>
            </v-toolbar>
            <v-divider></v-divider>
            
            <v-card-text class="pa-0">
              <v-data-table :rows-per-page-items="[50, 100]" :headers="complex.headers" :search="search" :items="appSettingData" items-per-page="-1"
                class="elevation-1" item-key="id" no-results-text="Нет результатов" v-model="complex.selected">
                <template slot="items" slot-scope="props">
                  <td style="background: #0058ff0a">{{ props.item.id }}</td>
                  <td style="background: #0058ff0a"><span style="background: #3f51b5;color: white;padding: 6px;padding-right: 6px;padding-left: 6px;padding-left: 1em;padding-right: 1em;border-radius: 4px;">{{ props.item.name }}</span></td>
                  <td style="font-style: italic;color:grey">{{ props.item.description ? props.item.description : 'Нет описания'}}</td>
                  <td>{{ props.item.valueGlobal ? props.item.valueGlobal : 'Не установлено' }}</td>
                  <td>
                    <v-btn depressed outline icon fab dark color="primary" small @click="editOpen(props.item)">
                      <v-icon>edit</v-icon>
                    </v-btn>
                    <!--<v-btn depressed outline icon fab dark color="pink" small @click="removeItemConfirm(props.item)">
                      <v-icon>delete</v-icon>
                    </v-btn>-->
                  </td>
                </template>
              </v-data-table>

              <!-- Редактирование -->
              <div slot="widget-content">

                <v-dialog v-model="popupEdit.isOpen" persistent max-width="500px">
                  <v-card>
                    <v-card-title>
                      <span class="headline" v-if="editedIndex !== -1">
                        Редактирование
                      </span>
                      <span class="headline" v-if="editedIndex === -1">
                        Добавление
                      </span>
                    </v-card-title>

                    <v-card-text>
                      <v-form ref="form" v-model="valid" lazy-validation>
                        <v-layout row v-if="readonlyFields">
                          <v-flex xs4>
                            <v-subheader>ID настройки</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <span label="ID настройки" readonly>{{ modalData.id }}</span>
                          </v-flex>
                        </v-layout>
                        <v-layout row>
                          <v-flex xs4>
                            <v-subheader>Наименование настройки</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <v-text-field label="Наименование настройки" v-model="modalData.name" :rules="rules.name"
                              required></v-text-field>
                          </v-flex>
                        </v-layout>
                        <v-layout row>
                          <v-flex xs4>
                            <v-subheader>Описание настройки</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <v-text-field label="Описание настройки"
                              v-model="modalData.description"></v-text-field>
                          </v-flex>
                        </v-layout>
                        <v-layout row>
                          <v-flex xs4>
                            <v-subheader>Глобальное значение</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <v-text-field label="Глобальное значение"
                              v-model="modalData.valueGlobal" required></v-text-field>
                          </v-flex>
                        </v-layout>
                        <v-layout row>
                          <v-flex xs4>
                            <v-subheader>Активно?</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <v-switch label="Активно?" v-model="modalData.isActive"
                            :rules="rules.isActive"></v-switch>
                          </v-flex>
                        </v-layout>
                      </v-form>
                    </v-card-text>
                    <v-card-actions>
                      <v-btn flat @click="editCancel()">Закрыть</v-btn>
                      <v-btn color="primary" flat @click="submit">Сохранить</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>

              </div>

              <!-- Удаление -->
              <div slot="widget-content">
                <v-dialog v-model="popupRemove.isOpen" persistent max-width="500px">
                  <v-card>
                    <v-card-title>
                      <span class="headline">Вы уверены что хотите удалить настройку?</span>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" flat @click.native="popupRemove.isOpen = false">Отмена</v-btn>
                      <v-btn color="blue darken-1" flat @click.native="actionRemove(modalData);">Да, уверен</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </div>

            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import colors from 'vuetify/es5/util/colors';

export default {
  components: {
  },

  data() {
    return {
      modalData: {},
      oldModalData: {},
      editedIndex: {},
      valid: true,
      readonlyFields: true,
      openColorBox: false,
      colors,
      rules: {
        required: [v => !!v || 'Обязательное поле'],
        code: [
          v => !!v || 'Ключ не может быть пустым',
          v => v.split(' ').length === 1 || 'Нельзя использовать пробелы',
          v => this.appSettingData.filter(el => el.code === v).length === 0 || 'Такой ключ уже существует',
        ],
      },
      search: '',
      popupRemove: {
        isOpen: false
      },
      popupEdit: {
        isOpen: false,
        isEditing: false,
      },
      complex: {
        selected: [],
        headers: [
          {
            text: 'ID',
            value: 'id'
          },
          {
            text: 'Наименование',
            value: 'name'
          },
          {
            text: 'Описание',
            value: 'description'
          },
          {
            text: 'Глобальное значение',
            value: 'valueGlobal'
          },
          {
            text: 'Действия',
            value: ''
          }
        ],
      }
    };
  },

  mounted: function () {
    /**
     * Загружаем данные по свойствам при первой отрисовке страницы
     */
    if (this.appSettingData.length === 0) {
      this.refresh();
    }
  },

  computed: {
    appSettingData() {
      return this.$store.getters['appsettings/items'];
    },
  },

  methods: {
    /**
     * Обновление данных по свойствам
     */
    refresh() {
      this.$store.dispatch('appsettings/loadItems');
    },

    /**
     * Открытие модального окна с редактированием, сохраняем старые данные и индекс элемента на случай отмены редактирования
     * @param item
     */
    editOpen(item) {
      // Если редактирование
      if (item !== null && typeof item !== 'undefined') {
        this.modalData = item;
        this.oldModalData = Object.assign({}, item);
        this.editedIndex = this.appSettingData.indexOf(item);
        this.readonlyFields = true;
        // Если добавление
      } else {
        this.modalData = {
          id: -1,
          name: '',
          description: '',
          isActive: true,
          valueGlobal: ''
        };

        this.oldModalData = {};
        this.editedIndex = -1;
        this.readonlyFields = false;
      }

      this.popupEdit.isOpen = true;
    },

    /**
     * Отмена редактирования
     */
    editCancel() {
      if (this.editedIndex != -1) {
        Object.assign(this.appSettingData[this.editedIndex], this.oldModalData);
      }

      this.popupEdit.isOpen = false;
    },

    submit() {
      if (this.$refs.form.validate()) {
        this.$store.dispatch('appsettings/save', { index: this.editedIndex, data: this.modalData })
          .then(() => {
            this.popupEdit.isOpen = false;
          });
      }
    },

    removeItemConfirm(data) {
      this.popupRemove.isOpen = true;
      this.modalData = data;
    },

    actionRemove(item) {
      this.$store.dispatch('appsettings/remove', { item });
      this.popupRemove.isOpen = false;
    },
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/ui/AppSettings.vue